// Hand-rolled SensorReading / SensorBatch proto decoder.
//
// We deliberately don't pull a full proto runtime (protobufjs / ts-proto)
// — the schema is two messages with three field types between them, and
// rolling our own keeps the dashboard bundle ~30KB lighter than
// protobufjs would. Schema ref: proto/laser/v1/sensor.proto.

const td = new TextDecoder('utf-8');

export interface DecodedReading {
  ts_ms: number;
  nums:  Record<string, number>;
  strs:  Record<string, string>;
}

export function decodeReading(buf: Uint8Array): DecodedReading {
  const r: DecodedReading = { ts_ms: 0, nums: {}, strs: {} };
  decodeReadingInto(buf, 0, buf.length, r);
  return r;
}

export function decodeBatch(buf: Uint8Array): DecodedReading[] {
  // SensorBatch.readings is field 1, repeated, length-delimited (tag 0x0A).
  const out: DecodedReading[] = [];
  let pos = 0;
  while (pos < buf.length) {
    const tag = buf[pos++];
    const fieldNum = tag >>> 3;
    const wire = tag & 7;
    if (fieldNum === 1 && wire === 2) {
      const [len, p2] = readVarint(buf, pos);
      pos = p2;
      const r: DecodedReading = { ts_ms: 0, nums: {}, strs: {} };
      decodeReadingInto(buf, pos, pos + len, r);
      out.push(r);
      pos += len;
    } else {
      pos = skipField(buf, pos, wire);
    }
  }
  return out;
}

function decodeReadingInto(buf: Uint8Array, start: number, end: number, out: DecodedReading): void {
  const view = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
  let pos = start;
  while (pos < end) {
    const [tag, p1] = readVarint(buf, pos);
    pos = p1;
    const fieldNum = tag >>> 3;
    const wire = tag & 7;
    if (fieldNum === 1 && wire === 0) {
      // ts_ms — int64 varint
      const [val, p2] = readVarint64(buf, pos);
      pos = p2;
      out.ts_ms = val;
    } else if (fieldNum === 2 && wire === 2) {
      // nums map entry
      const [len, p2] = readVarint(buf, pos);
      pos = p2;
      const stop = pos + len;
      let key = '', val = 0;
      while (pos < stop) {
        const [etag, p3] = readVarint(buf, pos);
        pos = p3;
        const ef = etag >>> 3, ew = etag & 7;
        if (ef === 1 && ew === 2) {
          const [klen, p4] = readVarint(buf, pos);
          pos = p4;
          key = td.decode(buf.subarray(pos, pos + klen));
          pos += klen;
        } else if (ef === 2 && ew === 1) {
          val = view.getFloat64(pos, true);
          pos += 8;
        } else {
          pos = skipField(buf, pos, ew);
        }
      }
      out.nums[key] = val;
    } else if (fieldNum === 3 && wire === 2) {
      // strs map entry
      const [len, p2] = readVarint(buf, pos);
      pos = p2;
      const stop = pos + len;
      let key = '', val = '';
      while (pos < stop) {
        const [etag, p3] = readVarint(buf, pos);
        pos = p3;
        const ef = etag >>> 3, ew = etag & 7;
        if (ef === 1 && ew === 2) {
          const [klen, p4] = readVarint(buf, pos);
          pos = p4;
          key = td.decode(buf.subarray(pos, pos + klen));
          pos += klen;
        } else if (ef === 2 && ew === 2) {
          const [vlen, p4] = readVarint(buf, pos);
          pos = p4;
          val = td.decode(buf.subarray(pos, pos + vlen));
          pos += vlen;
        } else {
          pos = skipField(buf, pos, ew);
        }
      }
      out.strs[key] = val;
    } else {
      pos = skipField(buf, pos, wire);
    }
  }
}

function readVarint(buf: Uint8Array, pos: number): [number, number] {
  let val = 0, shift = 0;
  while (pos < buf.length) {
    const b = buf[pos++];
    val |= (b & 0x7f) << shift;
    if ((b & 0x80) === 0) return [val >>> 0, pos];
    shift += 7;
  }
  return [val >>> 0, pos];
}

function readVarint64(buf: Uint8Array, pos: number): [number, number] {
  // Returns a JS number — fits all timestamps in any plausible range.
  let lo = 0, hi = 0, shift = 0;
  while (pos < buf.length) {
    const b = buf[pos++];
    if (shift < 28) {
      lo |= (b & 0x7f) << shift;
    } else if (shift < 32) {
      lo |= (b & ((1 << (32 - shift)) - 1)) << shift;
      hi |= (b & 0x7f) >>> (32 - shift);
    } else {
      hi |= (b & 0x7f) << (shift - 32);
    }
    if ((b & 0x80) === 0) break;
    shift += 7;
  }
  return [hi * 4294967296 + (lo >>> 0), pos];
}

function skipField(buf: Uint8Array, pos: number, wire: number): number {
  switch (wire) {
    case 0: { // varint
      while (pos < buf.length && (buf[pos++] & 0x80) !== 0) {}
      return pos;
    }
    case 1: return pos + 8;
    case 2: {
      const [len, p] = readVarint(buf, pos);
      return p + len;
    }
    case 5: return pos + 4;
    default: return buf.length;
  }
}
